import { SxProps, Theme } from '@mui/system';
import ThemeConstants from '../../../../../theme/ThemeConstants';

const classes = {
  container: {
    // mb: 2,
    paddingY: '12px',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '8px',
    mt: '12px',
  },
  barContainer: {
    pT: '16px',
    mt: '16px',
    borderTop: '1px solid',
    borderColor: 'common.border',
  },
  subContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    borderBottom: '1px solid',
    borderColor: ThemeConstants.common.border,
    mb: 1,
  },
  label: {
    fontSize: '14px',
    fontWeight: 400,
    color: 'common.grey850',
  },
  button: {
    padding: 0,
    height: 24,
  },
  menuText: {
    fontSize: 12,
  },
  requestContainer: {
    padding: 0,
    borderTop: '1px solid',
    borderColor: ThemeConstants.common.border,
    borderRadius: 0,
    mt: '16px',
    paddingTop: '16px',
  },
  shiftTypeContainer: {
    // mb: '12px',
    display: 'flex',
    flexDirection: 'column',
  },
  shiftLabelContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  shiftText: {
    fontSize: '16px',
    fontWeight: '600',
    ml: '6px',
  },
  singleShiftText: {
    color: 'chartColors.green170',
  },
  multipleShiftText: {
    color: 'chartColors.blue237',
  },
  rangeLabelContainer: {
    backgroundColor: 'common.newBlue',
    alignSelf: 'flex-start',
    paddingX: '10px',
    borderRadius: '50px',
    my: '8px',
    paddingY: '2px',
  },
  rangeLabel: {
    color: 'secondary.main',
    fontSize: '14px',
  },
  shiftIdentifierContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    mb: '16px',
  },
  deleteMessage: {
    fontSize: 14,
    fontWeight: '300',
    color: 'black',
    mb: '16px',
    mt: '8px',
    textAlign: 'center',
  },

  noteContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'common.lightBackgroundColor',
    p: '16px',
    mb: '16px',
  },
  noteText: {
    fontSize: 16,
    fontWeight: '600',
    color: 'common.grey850',
  },
  noteDescription: {
    fontSize: 12,
    color: 'common.grey850',
  },
  chipContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
